import { Native, NativeCurrency } from '@pulsex/sdk'
import { ChainId } from '@pulsex/chains'
import { useMemo } from 'react'
import { useActiveChainId } from './useActiveChainId'

export default function useNativeCurrency(): NativeCurrency {
  const { chainId } = useActiveChainId()
  return useMemo(() => {
    try {
      return Native.onChain(chainId)
    } catch (e) {
      return Native.onChain(ChainId.PULSECHAIN)
    }
  }, [chainId])
}
